import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { string, number, bool, element, func, oneOfType, arrayOf } from 'prop-types';
import { ArrowRight, ArrowBack } from '@magalu/stereo-ui-icons';
import Sidebar from '../Sidebar';
import FilterInput from '../../molecules/FilterInput';
import { Container, Title, FilterSelected, Content, TitleContainer, FilterDetailTitleContainer } from './filter-item-container.styles';

const FilterItemContainer = _ref => {
  let {
    onClick,
    label,
    position,
    filterSelected,
    fullScreen,
    showFilterInput,
    onChangeFilterInput,
    onClearInput,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick", "label", "position", "filterSelected", "fullScreen", "showFilterInput", "onChangeFilterInput", "onClearInput", "children"]);

  const [showFilterItemDetail, setShowFilterDetail] = useState(false);

  const handleOnClick = () => {
    setShowFilterDetail(true);
    onClick({
      label,
      position
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    onClick: handleOnClick,
    "data-testid": "filter-item-container"
  }), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, {
    fontSize: 1,
    "data-testid": "filter-item-container"
  }, label), filterSelected && /*#__PURE__*/React.createElement(FilterSelected, {
    as: typeof filterSelected !== 'string' ? 'div' : 'p',
    fontSize: 0,
    "data-testid": "filter-item-selected"
  }, filterSelected)), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(ArrowRight, {
    width: "12px",
    height: "12px"
  }))), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Sidebar, {
    direction: "right",
    visible: showFilterItemDetail,
    onClickOutside: () => setShowFilterDetail(false),
    fullScreen: fullScreen
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(FilterDetailTitleContainer, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(ArrowBack, {
    color: "#8c8c8c",
    "data-testid": "close-filter-detail",
    role: "button",
    title: "Fechar filtro",
    onClick: () => setShowFilterDetail(false)
  })), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Title, {
    fontSize: 1,
    textAlign: "center",
    fontWeight: "500"
  }, label))), /*#__PURE__*/React.createElement("div", null, showFilterInput && /*#__PURE__*/React.createElement(FilterInput, {
    m: '20px',
    onChange: onChangeFilterInput,
    onClearInput: onClearInput,
    label: label
  })), children))));
};

FilterItemContainer.defaultProps = {
  filterSelected: '',
  onClick: () => ({}),
  fullScreen: false
};
process.env.NODE_ENV !== "production" ? FilterItemContainer.propTypes = {
  label: string.isRequired,
  position: number,
  filterSelected: oneOfType([string, element]),
  showFilterInput: bool,
  fullScreen: bool,
  children: oneOfType([element, string, arrayOf(element)]),
  onChangeFilterInput: func,
  onClearInput: func,
  onClick: func
} : void 0;
export default FilterItemContainer;